import React from "react";
import Span from "../../../components/display/Span";
import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function NewEmailDialog({ string }) {
  const { t } = useTranslation();
  return (
    <Stack spacing={1}>
      <Typography>{t("ConfirmEmailChange")}</Typography>
      <Span text={string} />
    </Stack>
  );
}
